import { Input, Button } from "../../../../../../components"
import { Controller, useFormContext } from "react-hook-form"
import type { PersonalList } from "../../types"
import { useState } from "react"
import { usePersonalCode } from "../ChildItem/components/Item/utils"
interface PersonalProps {
  action?: "CREATE" | "UPDATE" | "DETAIL"
  data?: PersonalList
  isActiveSubmit?: boolean
  setFileValue: (newState: any) => void
  onSubmit: (newState: any) => void
  permission?: boolean
}

export const FormPersonalData: React.FC<PersonalProps> = ({ action, data, onSubmit, setFileValue, isActiveSubmit, permission }) => {
  const { control, setValue, getValues ,handleSubmit, formState} = useFormContext<PersonalList>()
  const { dataCode } = usePersonalCode()

  const [imageViews, setImageView] = useState<{ file: File | null; view: string | null }>({ file: null, view: null })
  const { REACT_APP_BASE_URL_API } = process.env

  return (
    <section>
      {/* Input Profile */}
      <>
        <div className="avatar flex justify-center mt-6 mb-10">
          <div className="w-[150px] rounded-full">
            {/* eslint-disable-next-line */}
            <img src={imageViews?.view 
              ? imageViews?.view
              : control?._formValues?.Customer_Foto
              ? `${REACT_APP_BASE_URL_API}/getimage/?imgpath=${control?._formValues?.Customer_Foto}`
              : "https://t4.ftcdn.net/jpg/05/17/53/57/360_F_517535712_q7f9QC9X6TQxWi6xYZZbMmw5cnLMr279.jpg"}
            />
          </div>
        </div>
        <Controller
          control={control}
          name="Customer_Foto"
          render={({ field }) => (
            <input 
              className="absolute mt-[-190px] ml-[100px] w-[150px] h-[150px] rounded-[50%] opacity-0" 
              type="file" 
              disabled={action === "DETAIL"} 
              onChange={(e) => {
                setFileValue(e.target.files?.[0])
                const selectedFile = e.target.files?.[0];
                field.onChange(e.target.files?.[0]);

                if (selectedFile) {
                  setImageView({ ...imageViews, file: selectedFile ?? control?._formValues?.Customer_Foto});
                  const reader = new FileReader();
                  reader.onloadend = () => {setImageView({ ...imageViews, view: reader.result as string})};
                  reader.readAsDataURL(selectedFile);
                } else {
                  setImageView({ ...imageViews, file: null, view:  null});
              }}}
            />
          )}
        />
      </>

      <>
        <Controller
          control={control}
          name="Customer_code"
          render={({ field }) => 
            <Input 
              {...field} 
              label="ID CUSTOMER" 
              value={action === "CREATE" ? dataCode?.customer_code : field.value } 
              disabled={true} 
            />
          }
        />
      </>
      <div className="flex items-top">
        <Controller
          control={control}
          name={action === "UPDATE" ? "Customer_Name" : "Customer_name"}
          render={({ field, fieldState }) => 
            <Input 
              {...field} 
              label="FULL NAME *" 
              className="w-full uppercase" 
              error={fieldState.error?.message}
              // error={action === "UPDATE" 
              //   ? control?._formValues?.Customer_Name ? "" : fieldState.error?.message
              //   : control?._formValues?.Customer_name ? "" : fieldState.error?.message
              // }
              placeholder="Input full name" 
              value={(field.value ?? data?.Customer_name ?? "").toUpperCase()} 
              onChange={(e) => {
                if(action === "UPDATE"){setValue("Customer_code", control?._defaultValues?.Customer_code)}else{setValue("Customer_code", dataCode?.customer_code)}
                if(action === "UPDATE"){setValue("Customer_Name", e.target.value.toUpperCase())}
                if(action === "CREATE"){setValue("Customer_name", e.target.value.toUpperCase())}
              }}
              disabled={action === "DETAIL"} 
            />
          }
        />
      </div>

      {/* Submit Button */}
      {action !== "DETAIL" && <div className="mt-5 flex justify-end">
        <Button 
          type="button"
          color="primary"
          loading={formState.isSubmitting ? "true" : undefined}
          onClick={handleSubmit(() => onSubmit(getValues()),(err)=> console.log(err))}
          disabled={isActiveSubmit}
          permission={"CR023"}
          >
          SAVE
        </Button>
      </div>}
    </section>
  )
}